import React from 'react';

import LoadHome from 'bundle-loader?lazy&name=home!./routes/home/home.jsx';
import LoadAbout from 'bundle-loader?lazy&name=about!./routes/about/about.jsx';
import LoadConfigure from 'bundle-loader?lazy&name=configure!./routes/configure/configure.jsx';

export const routes = [
    {
        pattern: '/',
        load: LoadHome,
        requireAuthentication: true,
        title: 'Home - Notifications Hatch'
    },
    {
        pattern: '/home',
        load: LoadHome,
        requireAuthentication: true,
        title: 'Home - Notifications Hatch'
    },
    {
        pattern: '/configure-notification/:discriminatorValue/notification/:notificationId/:notificationName/:mediumType',
        load: LoadConfigure,
        requireAuthentication: true,
        title: 'Configure - Notificiations Hatch'
    },
    {
        pattern: '/configure',
        load: LoadConfigure,
        requireAuthentication: true,
        title: 'Configure - Notificiations Hatch'
    },
    {
        pattern: '/configure/:discriminatorType',
        load: LoadConfigure,
        requireAuthentication: true,
        title: 'Configure - Notificiations Hatch'
    },
    {
        pattern: '/about',
        load: LoadAbout,
        requireAuthentication: true,
        title: 'About'
    }
];

const Bundle = ( Component ) => {
     
    return ( ( props ) => (
        <Component { ...props } />
    ) );
    };

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
	const { match } = nextRoute;

	if (
		match &&
		!match.render &&
		typeof match.load === 'function'
	) {
		match.load( ( asyncModule ) => {
			match.render = Bundle(
				asyncModule.default ?
					asyncModule.default
					:
					asyncModule, match.props
			);
			action.ok();
		} );
	} else {
		action.ok();
	}
}
